import { createSlice } from "@reduxjs/toolkit";
import {
  PostAddNotes,
  GetNotes,
  PutEditNotes,
  DeleteNotes,
} from "./NotesActions";
import { IAddTaskSlice } from "../../models/agent/Tasks/addTask";

export interface IPostAddNoteResponseData {
  id: string;
  providerId: string;
  customerId: string;
  createdTime: string | null;
  note: string;
}
export interface IGetNotesResponseData {
  id: string;
  providerId: string;
  customerId: string;
  createdTime: string | null;
  note: string;
}
export interface IEditNoteResponseData {
  id: string;
  providerId: string;
  customerId: string;
  createdTime: string | null;
  note: string;
}
export interface IDeleteNoteResponseData {
  id: string;
  providerId: string;
  customerId: string;
  createdTime: string | null;
  note: string;
}
export interface IAddNotes {
  addNotesResponse: IPostAddNoteResponseData | null;
  getNotesResponse: IGetNotesResponseData[] | null;
  editNotesResponse: IEditNoteResponseData | null;
  deleteNotesResponse: IDeleteNoteResponseData | null;
}
const initialState: IAddNotes = {
  addNotesResponse: null,
  getNotesResponse: null,
  editNotesResponse: null,
  deleteNotesResponse: null,
};
const addNoteSlice = createSlice({
  name: "addNote",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(PostAddNotes.fulfilled, (state, { payload }) => {
      state.addNotesResponse = payload.data;
    });
    builder.addCase(GetNotes.fulfilled, (state, { payload }) => {
      state.getNotesResponse = payload.data;
    });
    builder.addCase(PutEditNotes.fulfilled, (state, { payload }) => {
      state.editNotesResponse = payload.data;
    });
    builder.addCase(DeleteNotes.fulfilled, (state, { payload }) => {
      state.deleteNotesResponse = payload.data;
    });
  },
});

export default addNoteSlice.reducer;
